import { ComponentPropsWithoutRef, ElementType, Fragment, ReactElement } from 'react'

type DynamicTagProps<T extends ElementType> = {
  as?: T
} & ComponentPropsWithoutRef<T>

export function DynamicTag<T extends ElementType = 'div'>({
  as,
  children,
  ...props
}: DynamicTagProps<T>): ReactElement {
  const Component = as || 'div'

  const processChildren = (content: any): any => {
    if (typeof content === 'string') {
      const lines = content.split('\n')
      return lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </Fragment>
      ))
    }
    return content
  }

  return <Component {...props}>{processChildren(children)}</Component>
}
